import { useState } from "react";
import {
  Box,
  Text,
  Input,
  Flex,
  Button,
  Link,
  Icon,
  Divider,
  Center,Container,
} from "@chakra-ui/react";
import { BsArrowLeftCircle } from "react-icons/bs";
import toast from "react-hot-toast";

export interface SecondaryCta {
  text: string;
  link: string;
}

interface Props {
  username: string;
  id_str: string;
  secondaryCta?: SecondaryCta;
  editMode?: boolean;
}

export function CallToAction({
  secondaryCta,
  username,
  editMode = false,
  id_str
}: Props) {
  const [email, setEmail] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubscribe = async () => {
    try {
      setIsLoading(true);
      let dataToSend = {
        email,
        idUser: id_str,
      };

      let result = await fetch("/api/email/join", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });
      let response = await result.json();

      if (response.success) {
        toast.success(response.message);
      } else {
        toast.error("An error happened: " + response.error);
      }
    } catch (err) {
      console.log("Somthing went wrong in subscribing: ", err);
      toast.error("Something went wrong in subscribing: " + err.message);
    } finally {
      setIsLoading(false);
      setEmail("");
    }
  };

  return (
    <Box>
      <Box>
        <Container maxW='sm'>
        <Text  textAlign="center" textStyle="h4.bold.standard">
          Don't miss any threads from @{username}. Sign up and get them directly
          in your mailbox.
        </Text>
        </Container>

        <Flex gap={4} w="full" justifyContent="center" pt={4}>
          <Box>
            <Input
              type="email"
              mt={5}
              placeholder="john@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Box>
          {/* <Flex flexDir="column" alignItems="center"> */}
            <Button
              w="120px"
              isLoading={isLoading}
              mt={5}
              variant={"primary"}
              onClick={handleSubscribe}
            >
              Get Notified
            </Button>
          {/* </Flex> */}
        </Flex>

        <Divider mt="20" mb="16"  mx="auto" />
        {secondaryCta && (
          <Center mb="20">
            <Button
              as={Link}
              target="_blank"
              href={secondaryCta.link}
              // bg="gray.800"
              // color="white"
              // px="6"
              // colorScheme="none"
              _hover={{
                textDecor: "none",
              }}
              variant="tertiaryNoBackground"
            >
              {secondaryCta.text}
            </Button>
          </Center>
        )}
        <Center>
          <Link
            href="/thread-finder"
            display="flex"
            alignItems="center"
            target={editMode ? "_blank" : undefined}
          >
            <Icon as={BsArrowLeftCircle} />
            <Button ml={2} variant="tertiaryNoBackground"
>
              Discover other awesome creators
            </Button>
          </Link>
        </Center>
      </Box>
    </Box>
  );
}
